export default "__VITE_ASSET__0972c79f__"